/* globals Conf */
import React from 'react'
import { action, observable, autorun } from 'mobx'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import DataManipState from 'react-mobx-admin/state/data_manip'
import DataTableState from 'react-mobx-admin/state/data_table'
import moment from 'moment'
import { MenuItem } from 'react-bootstrap'

export function BaseManipStateFn (store) {
  return class BaseManipState extends DataManipState {
    //
    prepareNew () {
    }

    _onPrepared () {
      if (store.router.recordBackup) { // restore record backup
        this.record.merge(store.router.recordBackup)
        delete store.router.recordBackup
      }
      return super._onPrepared()
    }

    onLoaded (record) {
      super.onLoaded(record)
      this.cancelAutorun = autorun(this.flagEditing.bind(this))
    }

    createtitle = store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(defaultConst.TITLE_EDIT)
    saveText = store.__(defaultConst.TITLE_SAVE)
    cancelText = store.__(defaultConst.TITLE_CANCEL)
    saveAndReturnText = store.__(defaultConst.TITLE_SAVE_RETURN)

    onSaved (saved) {
      store.addMessage('successfully saved', 'success', 2000)
      this.flagEditDone()
      return this.requiredOptions && this.requiredOptions.length > 0
        ? store.loadAllOptions(this.requiredOptions).then(() => {
          super.onSaved(saved)
        })
        : super.onSaved(saved)
    }

    beforeSave (record) {
      return super.beforeSave(record)
    }

    onError (msg) {
      store.addMessage(store.__(msg), 'error', 2000)
    }

    flagEditDone () {
      const { entityname, id } = store.router.params
      delete this.recordState // have returned to starting state
      delete this.lockAcqiereFailed
      id && id !== '_new' && store.requester.call(`/state/${entityname}/${id}`, 'delete')
        .catch(store.onRequesterError.bind(store))
      clearInterval(this._sendFlagEditInterval)
    }

    flagEditStart () {
      const { entityname, id } = store.router.params
      id && id !== '_new' && store.requester
        .call(`/state/${entityname}/${id}`, 'get')
        .catch(store.onRequesterError.bind(store))
        .then(result => {
          if (!result.data || (result.data && result.data.length <= 0)) {
            store.requester.call(`/state/${entityname}/${id}`, 'post')
              .catch(_ => {
                this.lockAcqiereFailed = true
                store.onRequesterError.bind(store)
              })
          }
        }).catch(store.onRequesterError.bind(store))
    }

    updatePingCount = 0
    flagEditContinue () {
      this.updatePingCount++
      if (!this._sendFlagEditInterval) {
        const fn = this._sendFlagEditContinue.bind(this)
        this._sendFlagEditInterval = setInterval(fn, 60 * 1000)
      }
    }

    _sendFlagEditContinue () {
      if (this.updatePingCount === 0) return // send FlagEditContinue only once per min
      const { entityname, id } = store.router.params
      id && id !== '_new' && store.requester.call(`/state/${entityname}/${id}`, 'put')
        .then(() => this.updatePingCount = 0)
        .catch(err => { })
    }

    getRecordState () {
      const { entityname, id } = store.router.params
      return id && id !== '_new' && store.requester.call(`/state/${entityname}/${id}`, 'get')
    }

    @action save () {
      return Promise.resolve(
        this.beforeSave(JSON.parse(JSON.stringify(this.record))))
        .then(() => {
          const { entityname, id } = store.router.params
          if (id === '_new') { return super.save() }
          if (store.cv && store.cv.attrsState) { store.cv.attrsState = null }

          const getLock = this.getRecordState()
          const getLastMod = store.requester.call(`/${entityname}/${id}`, 'get')

          return Promise.all([getLock, getLastMod])
            .then(res => {
              const lastUpdated = new Date(res[1].data.updated_at)
              const myUpdated = new Date(this.record.get('updated_at'))
              if (lastUpdated > myUpdated) {
                // record has already been updated, RELOAD!
                alert('Record has already been updated, RELOADING!')
                return this.onLoaded(res[1].data)
              }
              if (res[0].data.length > 0 && this.lockAcqiereFailed) {
                const m = `${res[0].data} is editing this item, risk of mutual data overwrite! Really save?`
                const realySave = confirm(m)
                if (!realySave) return
              }
              return super.save().then(
                () => this.flagEditDone(entityname, id)
              )
            })
            .catch(store.onRequesterError.bind(store))
        })
    }

    flagEditing () {
      const record = JSON.stringify(this.record) // needed to be recalled on each record change
      if (this.isEntityChanged && !this.recordState) {
        if (this.entityname.modalEntity) {
          return true
        }
        this.recordState = this.getRecordState().then(res => {
          if (res.data && res.data.length > 0) {
            const m = `${res.data[0]} is editing this item, risk of mutual data overwrite! Continue?`
            const realyContinue = confirm(m)
            if (!realyContinue) {
              return store.onReturn2list()
            }
          }
          this.recordState = res.data
          this.flagEditStart()
        })
      } else if (!this.isEntityChanged && this.recordState) {
        this.flagEditDone()
      } else if (this.recordState) {
        this.flagEditContinue()
      }
    }

    init () {
      return this.requiredOptions && this.requiredOptions.length > 0
        ? store.loadAllOptions(this.requiredOptions).then(() => {
          return super.init()
        })
        : super.init()
    }
  }
}

const reportIds = [
  'id', 'name', 'purpose',
  'description', 'entity_filter',
  'entity_filter_default', 'link', 'type', 'query'
]
const REPORT4FILTER = 'reports4filter'

export class BaseTableState extends DataTableState {
  perPage = Conf.perPage || 50
  perPageOptions = [5, 10, 15, 20, 50, 100, 1000]
  requiredOptions = []
  customFilters = observable([])

  constructor (store, entityname, requester, router, updateQPars) {
    super(entityname, requester, router, updateQPars, store.dirty)
    // neccessary to load custom entity filters
    if (store.auth && store.auth.getToken()) {
      this.requiredOptions.push([REPORT4FILTER, `/reports?attrs=${JSON.stringify(reportIds)}`, 'name'])
      this.requiredOptions.push(['filterParameters', '/reports/parameters', 'id'])
    }
    this.store = store
  }

  _getCustomFilters () {
    const reports = this.store.options.has(REPORT4FILTER) && this.store.options.get(REPORT4FILTER)
    const filterParameters = this.store.options.has('filterParameters') ? this.store.options.get('filterParameters') : []

    const runForI = i => {
      const URLfilters = id => {
        const filters = Object.keys(this.router.queryParams)
          .filter(i => i[0] !== '_' &&
            (i.match(/^(\d+)_([^_]+)_custom__$/) ||
              i.match(/^(\d+)_(\w+)_(\d+)_custom__$/)))
          .map(i => parseInt(i.split('_')[0]))

        return filters.includes(id)
      }

      switch (true) {
      case (URLfilters(i.id)): {
        const name = `${i.id}_id_custom__`
        this.filters.set(name, this.router.queryParams[name] || '')
        i.parameters.forEach(p => {
          const name = `${i.id}_id_${p.id}_custom__`
          this.filters.set(name, this.router.queryParams[name] || '')
        })
        this.store.setEntityLastState(this.store.cv.entityname, this.router.queryParams)
      }
        break
      case (i.entity_filter_default === true && this.filters.size < 1): {
        const name = `${i.id}_id_custom__`
        this.filters.set(name, this.router.queryParams[name] || '')
        i.parameters.forEach(p => {
          const name = `${i.id}_id_${p.id}_custom__`
          this.filters.set(name, this.router.queryParams[name] || '')
        })
      }
        break
      }

      // Keep row filters
      Object.keys(this.router.queryParams)
        .filter(i => i[0] !== '_' && !i.match(/^(\d+)_([^_]+)_custom__$/) && !i.match(/^(\d+)_(\w+)_(\d+)_custom__$/))
        .map(i => this.filters.set(i, this.router.queryParams[i] || ''))
    }

    this.customFilters = reports && reports.filter(i => {
      return i.entity_filter && i.entity_filter === this.router.params.entityname && i.type === 'filter'
    })

    this.customFilters.map(i => {
      const parameters = filterParameters.filter(p => p.report_id === i.id)
      if (parameters) Object.assign(i, { parameters }) // assign parameters to filter object
      runForI(i)
    })
  }

  @action
  showFilter (filterName) {
    // clean only custom filters, not row filters
    if (filterName.match(/^(\d+)_([^_]+)_custom__$/)) {
      this.filters.forEach((f, n) => {
        if (n[0] !== '_' &&
          (n.match(/^(\d+)_([^_]+)_custom__$/) ||
            n.match(/^(\d+)_(\w+)_(\d+)_custom__$/))) {
          super.hideFilter(n)
        }
      })
    }

    const id = this._getCustomFilterId(filterName)
    if (id && this.filterParamCount(id) === 0) {
      this.updateFilterValue(filterName, 't')
      this.applyFilters()
    } else {
      super.showFilter(filterName)
    }
    this.store.setEntityLastState(this.store.cv.entityname, this.router.queryParams)
  }

  @action hideFilter (filterName) {
    // for row filter only remove but for custom filters remove all his "instances"
    if (filterName[0] !== '_' && !filterName.match(/^(\d+)_([^_]+)_custom__$/) && !filterName.match(/^(\d+)_(\w+)_(\d+)_custom__$/)) {
      super.hideFilter(filterName)
    } else {
      this.filters.forEach((f, n) => {
        if (n[0] !== '_' &&
          (n.match(/^(\d+)_([^_]+)_custom__$/) ||
            n.match(/^(\d+)_(\w+)_(\d+)_custom__$/))) {
          super.hideFilter(n)
        }
      })
    }
    this.store.setEntityLastState(this.store.cv.entityname, this.router.queryParams)
    if (linkConst.FILTER_REMOVE_SELECT.includes(filterName)) {
      this.store.platformFSelectorUpdate(filterName, null)
    }
  }

  @action applyFilters () {
    // deprecated - will be removed as soon as possible - for filter id 56 only
    const pId = '56_id_24_custom__'
    const pTest = this.router.queryParams && this.router.queryParams[pId]
    if (pTest && this.router.queryParams._sortField) {
      delete this.router.queryParams._sortDir
      delete this.router.queryParams._sortField
    }
    // ----------

    super.applyFilters()
    this.store.setEntityLastState(this.store.cv.entityname, this.router.queryParams)
  }

  _getCustomFilterId (filterName) {
    const m = filterName.match(/([0-9]+).*custom__/)
    return m ? Number(m[1]) : null
  }

  filterParamCount (filterID) {
    const filterItem = filterID ? this.customFilters.find(i => i.id === filterID) : null
    return filterItem && filterItem.parameters ? filterItem.parameters.length : 0
  }

  setPerPage (num) {
    this.router.queryParams._page = 1
    this.store.setUserPreferences('cargo_perPage', num)
    super.setPerPage(num)
  }

  init () {
    if (!this.store.auth.getToken()) {
      return super.init()
    }
    const required = [
      ...this.requiredOptions,
      [REPORT4FILTER, `/reports?attrs=${JSON.stringify(reportIds)}`, 'name'],
      ['filterParameters', '/reports/parameters', 'id']
    ]

    // deprecated - will be removed as soon as possible - for filter id 56 only
    const pId = '56_id_24_custom__'
    const pTest = this.router.queryParams && this.router.queryParams[pId]
    if (pTest && this.router.queryParams._sortField) {
      delete this.router.queryParams._sortDir
      delete this.router.queryParams._sortField
    }
    // ----------

    return this.store.loadAllOptions(required).then(() => {
      const filterParameters = this.store.options.has('filterParameters') && this.store.options.get('filterParameters')

      const filters = this.store.options.has(REPORT4FILTER) && this.store.options.get(REPORT4FILTER).filter(i => {
        return i.entity_filter && i.entity_filter === this.router.params.entityname && i.type === 'filter'
      }).map(f => filterParameters.filter(p => p.report_id === f.id))

      const options = []
      filters.forEach(t => t.forEach(da => {
        if (da.options_attr) options.push(da.options_attr)
      }))

      return this.store.loadAllOptions(options).then(() => {
        this.store.entityLastState[this.store.cv.entityname] &&
          this.updateQPars(Object.assign(this.store.entityLastState[this.store.cv.entityname], { _perPage: this.store.getUserPreferences('cargo_perPage') })) ||
          this.store.setEntityLastState(this.store.cv.entityname, this.router.queryParams)

        super.init()

        if (filters.length > 0) {
          this._getCustomFilters()
        } else {
          Object.keys(this.router.queryParams)
            .filter(i => i[0] !== '_' && !i.match(/^(\d+)_([^_]+)_custom__$/) && !i.match(/^(\d+)_(\w+)_(\d+)_custom__$/))
            .map(i => this.filters.set(i, this.router.queryParams[i] || ''))
        }
      })
    })
  }

  disableUpdate (items = [], selection = [], validDate = moment()) {
    return selection.some(s => items[s].valid_to && moment(items[s].valid_to).isBefore(validDate))
  }

  disableEditDelete (items = [], selection = [], validDate = moment()) {
    return selection.some(s => items[s].valid_to && moment(items[s].valid_to).isBefore(validDate)) ||
    selection.some(s => items[s].valid_from && moment(items[s].valid_from).isSameOrBefore(validDate))
  }

  disableMenuInfo = [
    <MenuItem key={'div'} divider />,
    <MenuItem key={'inf'}><em>*/ prohibition of updating live/old items</em></MenuItem>
  ]

  // Create NEW button
  addText = [
    (<em key={0} className='glyphicon glyphicon-plus-sign' />),
    (<span key={1}>&nbsp;{defaultConst.TITLE_CREATE}</span>)
  ]

  getPerPage () {
    const qp = this.router.queryParams || {}
    return qp._perPage || this.store.getUserPreferences('cargo_perPage') || this.perPage
  }

  setDefaults () {
    const qp = this.router.queryParams || {}
    qp._perPage = qp._perPage ? qp._perPage : this.getPerPage()
    super.setDefaults()
  }
}
